import type { CheckoutCartHistoryItem, Kiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchCheckoutKiosks, fetchRecentCheckoutCarts } from '../queries/checkoutKiosk.queries'

export const useCheckoutKiosks = (
  storeId: number,
  enabled = true,
): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId],
    queryFn: () => fetchCheckoutKiosks(storeId),
    enabled,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 4000,
  })

export const useRecentCheckoutCarts = (
  storeId: number,
  enabled = true,
): UseQueryResult<CheckoutCartHistoryItem[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId, 'recent-carts'],
    queryFn: () => fetchRecentCheckoutCarts(storeId),
    enabled,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 4000,
  })
